import Home from '../assests/Home.png'
import Gallery from '../assests/Gallery.png'
import Agenda from '../assests/Agenda.png'
import Bronchure from '../assests/Bronchure.png'
import Exibitor from '../assests/Exibitor.png'
import Feedback from '../assests/Feedback.png'
import floorplan from '../assests/floorplan.png'
import SideEvent from '../assests/SideEvent.png'
import Speaker from '../assests/Speaker.png'
import Sponsor from '../assests/Sponsor.png'
import Userguide from '../assests/Userguide.png'
import ContactUs from '../assests/ContactUs.png'
import FirstFull from '../assests/Firstfull.png'
import FirstCent from '../assests/FirstCent.png'
import SecondFull from '../assests/SecondFull.png'
import SecondCent from '../assests/SecondCent.png'
import ThirdFull from '../assests/ThirdFull.png'
import ThirdCent from '../assests/ThirdCent.png'
import SideFull from '../assests/SideFull.png'
import SideCent from '../assests/SideCent.png'
import Side2Full from '../assests/Side2Full.png'
import Side2Cent from '../assests/Side2Cent.png'
import Side3Full from '../assests/Side3Full.png';
import Side4Full from '../assests/Side4Full.png'
import Side4Cent from '../assests/Side4Cent.png'
import roundimg from '../assests/roundimg.png'
import HouseFoot from '../assests/HouseFoot.png'
import BellFoot from '../assests/BellFoot.png'
import StackFoot from '../assests/StackFoot.png'
import UserFoot from '../assests/UserFoot.png'
import CsideEvent from '../assests/CsideEvent.png'
import Cagenda from '../assests/Cagenda.png'
import Cspeaker from '../assests/Cspeaker.png';
import Cexbitor from '../assests/Cexbitor.png'
import Csponsor from '../assests/Csponsor.png'
import Cfloorplan from '../assests/Cfloorplan.png'
import Cbronchore from '../assests/Cbronchure.png'
import Cgallery from '../assests/Cbronchure.png'
import Ccontact from '../assests/Ccontact.png'


export const navLinks = [
    {
      link:"/Home",
      id: "home",
      title: "Home",
      img:Home
    },
    {
      link:"/SideEvent",
      id: "Side Events",
      title: "Side Events",
      img:SideEvent
    },
    {
      link:"/Agenda",
        id: "Agenda",
        title: "Agenda",
        img:Agenda
      },
      {
        link:"/Speakers",
        id: "Speaker",
        title: "Speaker",
        img:Speaker
      },
    {
      link:"/Category",
      id: "Exibitor",
      title: "Exibitor",
      img:Exibitor
    },
    {
      id: "Sponsors",
      title: "Sponsors",
      img:Sponsor
    },
    {
        id: "Floor Plan",
        title: "Floor Plan",
        img:floorplan
      },
      {
        
        id: "Bronchure",
        title: "Bronchure",
        img:Bronchure
      },
      {
        id: "Gallery",
        title: "Gallery",
        img:Gallery
      },
      {
        id: "Feedback",
        title: "Feedback",
        img:Feedback
      },
      {
        id: "Contact Us",
        title: "Contact Us",
        img:ContactUs
      },
      {
        
        id: "User Guide",
        title: "User Guide",
        img:Userguide
      },
  ];


  export const SideEve =[
    {
      img1:SideFull,
      img2:SideCent,
      furm:"Women in Future Energies",
      dates:"Dec 12, 2024",
      loc:"Muscat, Sultanate of Oman"
    },
    {
      img1:Side2Full,
      img2:Side2Cent,
      furm:"Energy Executive Circle",
      dates:"Dec 13, 2024",
      loc:"Muscat, Sultanate of Oman"
    },
    {
      img1:Side3Full,
      img2:'',
      furm:"EU Summit",
      dates:"Dec 13, 2024",
      loc:"Muscat, Sultanate of Oman"
    },
    {
      img1:Side4Full,
      img2:Side4Cent,
      furm:"TecH2 Stage",
      dates:"Dec 12-14, 2024",
      loc:"Cairo, Egypt"
    }

  ]



  export const Homepage =[
    {
      img1:FirstFull,
      img2:FirstCent,
      furm:"CCUS Forum",
      dates:"Apr 26-28, 2024",
      loc:"Muscat, Sultanate of Oman"
    },
    {
      img1:SecondFull,
      img2:SecondCent,
      furm:"Green Hydrogen Summit Oman",
      dates:"Dec 12-14, 2024",
      loc:"Muscat, Sultanate of Oman"
    },
    {
      img1:ThirdFull,
      img2:ThirdCent,
      furm:"Cairo Sustainable Energy Week",
      dates:"Oct 1-3, 2024",
      loc:"Cairo, Egypt"
    }

  ]

  


 export const SpeakerArry =[
  {
    img:roundimg,
    text:"Johnathan N. Killip",
    text2:"[Job Title]",
    text3:"[Company Name]"
  },
  {
    img:roundimg,
    text:"Johnathan N. Killip",
    text2:"[Job Title]",
    text3:"[Company Name]"
  },
  {
    img:roundimg,
    text:"Johnathan N. Killip",
    text2:"[Job Title]",
    text3:"[Company Name]"
  }
 ]


 export const Foot =[
  {
   im:UserFoot
  },
  {
    im:StackFoot
  },
  {
    im:BellFoot
  },
  {
    im:HouseFoot
  }
 ]



 export const CateArry =[
  {
    id:1,
    Cimg:CsideEvent,
    txt:"Side Event"
  },
  {
    id:2,
    Cimg:Cagenda,
    txt:"Agenda"
  },
  {
    id:3,
    Cimg:Cspeaker,
    txt:"Speaker"
  },
  {
    id:4,
    Cimg:Cexbitor,
    txt:"Exibitor"
  },
  {
    id:5,
    Cimg:Csponsor,
    txt:"Sponsor"
  },
  {
    id:6,
    Cimg:Cfloorplan,
    txt:"Floor plan"
  },
  {
    id:7,
    Cimg:Cbronchore,
    txt:"Bronchure"
  },
  {
    id:8,
    Cimg:Cgallery,
    txt:"Gallery"
  },
  {
    id:9,
    Cimg:Ccontact,
    txt:"Contact"
  }

 ]